<div class="dashboard-title">
    {{ title() }}
    <app-info-tooltip [title]="tooltipText()"></app-info-tooltip>
</div>
<div class="dashboard-subtitle">
    {{ subtitle() }}
</div>
